<div class="border">
  @for (day of weekDays; track day) {
    <button
      [attr.data-test-id]="'weekday-button_' + day[1] | lowercase"
      class="weekday-button"
      type="button"
      [ngClass]="{ active: value | arrayContains: day[1] }"
      (click)="toggleWeekDay(day[1])"
      >
      {{ day[0] }}
      @if (value.includes(day[1])) {
        <img src="./assets/svgs/check_outline_white.svg" />
      }
    </button>
  }
</div>
